const powerfulSlider = new Swiper('.powerfulSlider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView:2.3,
    // If we need pagination
    pagination: {
      clickable:true,
      el: '.swiper-pagination',
    },
  

  
  });

  let slider1 = document.querySelector(".mySwiper");
  if (slider1) {
      var swiper2 = new Swiper(".mySwiper",{
          spaceBetween: 10,
          slidesPerView: 4,
          navigation: {
              nextEl: ".buy-product-thumb-arrow-right",
              prevEl: ".buy-product-thumb-arrow-left"
          },
          breakpoints: {
              320: {
                  direction: "horizontal",
                  slidesPerView: 4
              },
              650: {
                  direction: "vertical"
              },
              1024: {
                  direction: "horizontal"
              }
          }
      });
      let lastActiveIndex = swiper2.activeIndex;
      swiper2.slides.forEach( (slide, index) => {
          slide.addEventListener("click", function() {
              const currentIndex = swiper2.activeIndex;
              if (index > currentIndex)
                  localStorage.setItem("previousActiveIndex", lastActiveIndex.toString()),
                  lastActiveIndex = index;
              else if (index < currentIndex)
                  localStorage.setItem("previousActiveIndex", lastActiveIndex.toString()),
                  lastActiveIndex = index;
              else
                  return;
              localStorage.setItem("currentActiveIndex", index.toString());
              let previousActiveIndex = parseInt(localStorage.getItem("previousActiveIndex"))
                , currentActiveIndex = parseInt(localStorage.getItem("currentActiveIndex"));
              currentActiveIndex > previousActiveIndex ? swiper2.slideNext() : currentActiveIndex < previousActiveIndex && swiper2.slidePrev()
          })
      }
      )
  }
  let slider2 = document.querySelector(".mySwiper2");
  if (slider1)
  var swiperMain = new Swiper(".mySwiper2",{
      spaceBetween: 10,
      navigation: {
          nextEl: ".buy-product-slider-next",
          prevEl: ".buy-product-slider-prev"
      },
      pagination: {
          el: ".buy-product-pagination",
          clickable: !0
      },
      thumbs: {
          swiper: swiper2
      }
  });
 